import React, { Component } from 'react';
import { Create, SimpleForm, TextInput} from 'react-admin';


export default class CompanyRoleOptionsCreate extends Component{
    render(){
        return(
            <Create {...this.props} title="Crear rol de empresas">
                <SimpleForm>
                    <TextInput source="name" label="Nombre"/>
                </SimpleForm>
            </Create>
        )
    }
}